function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module alignment/alignmentui
 */
import { Plugin, icons } from 'ckeditor5/src/core';
import { ButtonView, createDropdown, addToolbarToDropdown } from 'ckeditor5/src/ui';
import { isSupported, normalizeAlignmentOptions } from './utils';
var iconsMap = new Map([['left', icons.alignLeft], ['right', icons.alignRight], ['center', icons.alignCenter], ['justify', icons.alignJustify]]);
/**
 * The default alignment UI plugin.
 *
 * It introduces the `'alignment:left'`, `'alignment:right'`, `'alignment:center'` and `'alignment:justify'` buttons
 * and the `'alignment'` dropdown.
 *
 * @extends module:core/plugin~Plugin
 */

var AlignmentUI = /*#__PURE__*/function (_Plugin) {
  _inherits(AlignmentUI, _Plugin);

  var _super = _createSuper(AlignmentUI);

  function AlignmentUI() {
    _classCallCheck(this, AlignmentUI);

    return _super.apply(this, arguments);
  }

  _createClass(AlignmentUI, [{
    key: "localizedOptionTitles",
    get:
    /**
     * Returns the localized option titles provided by the plugin.
     *
     * The following localized titles corresponding with
     * {@link module:alignment/alignment~AlignmentConfig#options} are available:
     *
     * * `'left'`,
     * * `'right'`,
     * * `'center'`,
     * * `'justify'`.
     *
     * @readonly
     * @type {Object.<String,String>}
     */
    function get() {
      var t = this.editor.t;
      return {
        'left': t('Align left'),
        'right': t('Align right'),
        'center': t('Align center'),
        'justify': t('Justify')
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;

      var editor = this.editor;
      var componentFactory = editor.ui.componentFactory;
      var t = editor.t;
      var options = normalizeAlignmentOptions(editor.config.get('alignment.options'));
      options.map(function (option) {
        return option.name;
      }).filter(isSupported).forEach(function (option) {
        return _this._addButton(option);
      });
      componentFactory.add('alignment', function (locale) {
        var dropdownView = createDropdown(locale); // Add existing alignment buttons to dropdown's toolbar.

        var buttons = options.map(function (option) {
          return componentFactory.create("alignment:".concat(option.name));
        });
        addToolbarToDropdown(dropdownView, buttons); // Configure dropdown properties an behavior.

        dropdownView.buttonView.set({
          label: t('Text alignment'),
          tooltip: true
        });
        dropdownView.toolbarView.isVertical = true;
        dropdownView.toolbarView.ariaLabel = t('Text alignment toolbar');
        dropdownView.extendTemplate({
          attributes: {
            class: 'ck-alignment-dropdown'
          }
        }); // The default icon depends on the direction of the content.

        var defaultIcon = locale.contentLanguageDirection === 'rtl' ? iconsMap.get('right') : iconsMap.get('left'); // Change icon to reflect current selection's alignment.

        dropdownView.buttonView.bind('icon').toMany(buttons, 'isOn', function () {
          for (var _len = arguments.length, areActive = new Array(_len), _key = 0; _key < _len; _key++) {
            areActive[_key] = arguments[_key];
          }

          // Get the index of an active button.
          var index = areActive.findIndex(function (value) {
            return value;
          }); // If none of the commands is active, display either defaultIcon or the first button's icon.

          if (index < 0) {
            return defaultIcon;
          } // Return active button's icon.


          return buttons[index].icon;
        }); // Enable button if any of the buttons is enabled.

        dropdownView.bind('isEnabled').toMany(buttons, 'isEnabled', function () {
          for (var _len2 = arguments.length, areEnabled = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            areEnabled[_key2] = arguments[_key2];
          }

          return areEnabled.some(function (isEnabled) {
            return isEnabled;
          });
        });
        return dropdownView;
      });
    }
    /**
     * Helper method for initializing the button and linking it with an appropriate command.
     *
     * @private
     * @param {String} option The name of the alignment option for which the button is added.
     */

  }, {
    key: "_addButton",
    value: function _addButton(option) {
      var _this2 = this;

      var editor = this.editor;
      editor.ui.componentFactory.add("alignment:".concat(option), function (locale) {
        var command = editor.commands.get('alignment');
        var buttonView = new ButtonView(locale);
        buttonView.set({
          label: _this2.localizedOptionTitles[option],
          icon: iconsMap.get(option),
          tooltip: true,
          isToggleable: true
        }); // Bind button model to command.

        buttonView.bind('isEnabled').to(command);
        buttonView.bind('isOn').to(command, 'value', function (value) {
          return value === option;
        }); // Execute command.

        _this2.listenTo(buttonView, 'execute', function () {
          editor.execute('alignment', {
            value: option
          });
          editor.editing.view.focus();
        });

        return buttonView;
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return 'AlignmentUI';
    }
  }]);

  return AlignmentUI;
}(Plugin);

export { AlignmentUI as default };